import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

export type MenuListItem = {
  text: string;
  callback: (item: MenuListItem) => void;
}

type MenuSource = 'timestamp-above' | 'custom-milestone' | 'timestamp-below' | 'activity'

export type MenuUpdate = {
  pos: {
    x: number,
    y: number
  },
  items: Array<MenuListItem>
}

@Injectable({
  providedIn: 'root'
})
export class ContextMenuService {
  readonly MENU_SOURCE_ITEM_MAP: Record<MenuSource, MenuListItem> = {
    "timestamp-above": {
      text: "Create custom milestone",
      callback: (_: MenuListItem) => {},
    },
    "custom-milestone": {
      text: "Delete custom milestone",
      callback: (_: MenuListItem) => {},
    },
    "timestamp-below": {
      text: "Create activity",
      callback: (_: MenuListItem) => {},
    },
    "activity": {
      text: "Delete activity",
      callback: (_: MenuListItem) => {},
    }
  }

  private menuItemsSubject = new Subject<MenuUpdate>()
  menuItemsData = this.menuItemsSubject.asObservable()
  /**
   * Gathers all list items inserted in reversing order of elements that have a listener to the contextmenu event.
   * As Events in HTML are triggered on all hitboxes under the x and y coordinates, triggering the most nested element first.
   * This allows for example a timestamp to add one list item. If an element inside the timestamp add a list item too it
   * will be placed after the timestamp list item.
   */
  tempItemStorage: Array<MenuListItem> = []

  addItemToNextOpen(source: MenuSource, callback: (item: MenuListItem) => void) {
    const copy = Object.assign({}, this.MENU_SOURCE_ITEM_MAP[source]) as MenuListItem
    copy.callback = callback
    this.tempItemStorage.unshift(copy)
  }

  openMenu(x: number, y: number) {
    this.menuItemsSubject.next({
      pos: {
        x,
        y
      },
      items: this.tempItemStorage
    })

    this.tempItemStorage = []
  }
}
